export default "__VITE_ASSET__CMgCrMay__"